import axios from "axios";

export const state = {
    subjectdetails: [],
};

export const getters = {
    subjectdetails: state => state.subjectdetails,
};

export const mutations = {
    setSubject(state, newValue) {
        state.subjectdetails = newValue
    },
};

export const actions = {
    fetchSubjectDetails({ commit }) {
        axios.get('/subjectdetails').then(res => {
            commit('setSubject', res.data.subjectdetails);
        })
    },
};
